/* icconX help assistant helpers (15 Oct 2026). Header always says "Active now" (owner decision, 15 Oct). IXA_BACK() tells
   the flows when the team (Mon-Sat 10 AM-6 PM IST) next replies, using holidays/festive from #IxaConfig. WhatsApp links in
   the chat open in a new tab with the green chip look. */
(function () {
  var cfgEl = document.getElementById('IxaConfig'); if (!cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent), D = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function ist(d) {
    var o = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', weekday: 'short', hour: 'numeric', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return { day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday), hour: parseInt(o.hour, 10) % 24, date: o.year + '-' + o.month + '-' + o.day };
  }
  function working(t) { return (cfg.holidays || []).indexOf(t.date) < 0 && (cfg.festive || t.day !== 0); }
  window.IXA_BACK = function () {
    var now = Date.now(), t = ist(new Date(now));
    if (working(t) && t.hour >= 10 && t.hour < 18) return '';
    if (working(t) && t.hour < 10) return 'today at 10 AM';
    for (var i = 1; i < 9; i++) { var x = ist(new Date(now + i * 864e5)); if (working(x)) return (i === 1 ? 'tomorrow' : D[x.day]) + ' at 10 AM'; }
    return 'at 10 AM';
  };
  /* WhatsApp links in the chat open in a new tab and get the green chip look. */
  var log = document.getElementById('IxaLog');
  if (log && window.MutationObserver) new MutationObserver(function () {
    log.querySelectorAll('a[href*="wa.me"]:not([target])').forEach(function (a) { a.target = '_blank'; a.rel = 'noopener'; if (!a.closest('.ixa-opts--buttons')) a.className = 'ixa-chip ixa-chip--wa'; });
  }).observe(log, { childList: true, subtree: true });
})();
